import _ from 'lodash';
import Mustache from 'mustache';
import i18next from 'i18next';

// Original functions from platform_project/theme/src/js/utils/language.js

function formattedDefault(defaultString, dynamic) {
  if (typeof defaultString === 'object' && !Array.isArray(defaultString)) {
    if (dynamic && 'count' in dynamic) {
      return Mustache.render(
        dynamic.count === 1 ? defaultString.single : defaultString.plural,
        dynamic,
      );
    } else {
      return Mustache.render(defaultString.single, dynamic);
    }
  }

  if (_.isEmpty(dynamic)) return defaultString;

  return Mustache.render(defaultString, dynamic);
}

export const translate = (key, defaultString, dynamic = {}, i18n) => {
  let hash;

  if (typeof window !== 'undefined') {

    hash = window.location.hash;

    // Return key for keyView
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams.has('keyView') || hash?.includes('keyView=true')) return key;
  }

  const i18nToUse = (i18n?.exists && i18n?.t && i18n) || i18next;
  if (!key || !i18nToUse?.exists(key, dynamic)) {
    return formattedDefault(defaultString, dynamic);
  }

  // Return translated string
  return i18nToUse.t(key, dynamic);
};
